import { put, call, takeLatest } from "redux-saga/effects";

import * as loadingActions from "./actions/loading";
import * as slideDeckActions from "./actions/slide_decks";
import requestData from "../shared/request_data";
import { AJAX } from "../shared/make_ajax_action";

// functions below use requestData and then put options to modify the store based on the response

function* chartDataRequest(action) {
  yield put({
    type: loadingActions.LOADING_DATA_STARTED,
    sectionChanged: action.sectionChanged,
    sectionSlug: action.sectionSlug,
    tabSlug: action.tabSlug,
    tabChanged: action.tabChanged
  });

  const json = yield call(requestData, action);

  yield put({ type: loadingActions.DATA_LOADED, data: json });

  yield put({ type: loadingActions.LOADING_DATA_FINISHED });
}

function* slideDeckRequest(action) {
  let started, mapper, loaded, finished;
  if (action.triggeringType === slideDeckActions.CHART_SLIDE_DECK_BUTTON_CLICKED) {
    started = slideDeckActions.SD_LOADING_OPTIONS_STARTED;
    loaded = slideDeckActions.SD_OPTIONS_LOADED;
    finished = slideDeckActions.SD_LOADING_OPTIONS_FINISHED;

    mapper = (e) => ({ label: e.name, value: e.id });
  } else {
    started = slideDeckActions.SD_SUBMIT_STARTED;
    loaded = slideDeckActions.SD_SUBMITTED;
    finished = slideDeckActions.SD_SUBMIT_FINISHED;

    mapper = (e) => e;
  }

  yield put({
    type: started
  });

  const json = yield call(requestData, action);

  let data = json.map(mapper);

  yield put({ type: loaded, data: data });

  yield put({ type: finished });
}

// delegates to a fetch* functon based on the action triggeringType
function* handleAjax(action) {
  const slideDeckAction = [
    slideDeckActions.CHART_SLIDE_DECK_BUTTON_CLICKED,
    slideDeckActions.SUBMIT_SLIDE_DECK_BUTTON_CLICKED
  ].find((e) => e === action.triggeringType);

  if (slideDeckAction) {
    yield slideDeckRequest(action);
  } else {
    yield chartDataRequest(action);
  }
}

export default function* rootSaga() {
  yield takeLatest(AJAX, handleAjax);
}
